import React, { PureComponent } from 'react';

import InputTextEditor from './input-text-editor';
import NiftyMarkdown from './nifty-markdown';

import IconInfo from '../icons/icon-info';

export default class DescriptionPane extends PureComponent {
    static defaultProps = {
        content: '',
        placeholder: 'Add a description...',
        emptyPlaceholder: 'No description'
    }

    state = {
        editing: false,
        focus: false
    }

    handleBlur = () => {
        this.save();
    }

    handleSaveClick = () => {
        this.save();
    }

    handleSubmit = () => {
        this.editorCtrl && this.editorCtrl.blur();
    }

    handleFocus = () => {
        this.setState({
            editing: true,
            focus: true
        });
    }

    handlePaneClick = e => {
        if (!this.props.editable || e.target.tagName === 'A') {
            e.target.target = '_blank';
            return;
        }

        this.startEdit();
    }

    handlePaste = e => {
        e.preventDefault();

        const text = (e.originalEvent || e).clipboardData.getData('text/plain');

        document.execCommand('insertHTML', false, text);
    }

    save() {
        const hasContent = this.editorCtrl.isPopulated();
        const content = this.editorCtrl.getSerializedText();

        this.setState({
            editing: false,
            focus: false
        });

        if (this.props.content === content) {
            return;
        }

        this.props.onChange && this.props.onChange(hasContent ? content : null);
    }

    startEdit() {
        this.setState({
            editing: true
        }, () => {
            this.editorCtrl && this.editorCtrl.focus()
        });
    }

    setCtrl = ctrl => this.editorCtrl = ctrl;

    render() {
        return (
            <div className="description-pane">
                <div className="icon">
                    <IconInfo />
                </div>

                <div className={'description-body' + (this.state.focus ? ' description-focus' : '')}>
                    {
                        this.props.forceEdit || (this.state.editing && this.props.editable) ? (
                            <React.Fragment>
                                <div className="description-scrollable">
                                    <InputTextEditor
                                        id={this.props.id}
                                        value={this.props.content}
                                        placeholder={this.props.placeholder}
                                        provideController={this.setCtrl}
                                        enterToSubmit={false}
                                        users={this.props.users}
                                        onFocus={this.handleFocus}
                                        onBlur={this.handleBlur}
                                        onSubmit={this.handleSubmit}
                                        onPaste={this.handlePaste}
                                        onFilesPaste={this.props.onFilesPaste}
                                    />
                                </div>

                                <div className="description-save btn btn-success btn-xxsmall">Save</div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="description-scrollable">
                                    <div className="pane" onClick={this.handlePaneClick}>
                                        <NiftyMarkdown placeholder={this.props.emptyPlaceholder}>{this.props.content}</NiftyMarkdown>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
        )
    }
}
